import { Auth } from './modules/auth';
import { Downloads } from './modules/downloads';
import { Valoration_Course } from './modules/valoration_course';
import { WPFORO } from './modules/wpforo';

document.addEventListener('DOMContentLoaded', () => {
  let $ = jQuery;
  feather.replace();

  $('.user_button_menu').click(function () {
    if ($('.logged').hasClass('active')) {
      $('.logged').removeClass('active');
      $('.open_user_menu').fadeOut('fast');
    } else {
      $('.logged').addClass('active');
      $('.open_user_menu').fadeIn('fast');
    }
  });
  $('.open_menu').click(function () {
    $('header .md_content').addClass('open');
  });
  $('.close_menu').click(function () {
    $('header .md_content').removeClass('open');
  });
  $('.input_single.password .eye_close').click(function () {
    $('.input_single.password input').attr('type', 'text');
    $('.input_single.password .eye_close').hide();
    $('.input_single.password .eye_open').show();
  });
  $('.input_single.password .eye_open').click(function () {
    $('.input_single.password input').attr('type', 'password');
    $('.input_single.password .eye_open').hide();
    $('.input_single.password .eye_close').show();
  });
  $('.open_forget_password').click(function () {
    $('.user_form').hide();
    $('.forgot_password').fadeIn('fast');
  });
  $('.open_register').click(function () {
    $('.user_form').hide();
    $('.register').fadeIn('fast');
  });
  $('.back_login').click(function () {
    $('.user_form').hide();
    $('.login').fadeIn('fast');
  });
  $('.sc_content').owlCarousel({
    loop: false,
    nav: true,
    dots: true,
    navText: [
      '<i class="icon chevron_left"></i>',
      '<i class="icon chevron_right"></i>',
    ],
    items: 1,
  });
  $('.scroll_top').click(function () {
    $('html').scrollTop(0);
  });

  $('#slider_home').owlCarousel({
    loop:true,
    nav:true,
    items:1
})
  $('.open_forget_email').click(function () {
    $('.forgot_password').hide();
    $('.recover_email').fadeIn('fast');
    jQuery('#recover_email_form_content').show();
    jQuery('#show_email_success').hide();
    jQuery('#recover_mail_dni').val('');
    jQuery('#resultRecoveryForm .error_form').text('')
  });

  // hover botones de topics en home
  $('.home_button_topic').on('mouseenter', function (e) {
    const colorRGBA = $(this).data('bgcolor-hover');
    $(this).css({ backgroundColor: colorRGBA, borderColor: colorRGBA });
  });
  $('.home_button_topic').on('mouseleave', function (e) {
    const color = $(this).data('color');
    $(this).css({ backgroundColor: color, borderColor: color });
  });

  //Course home

  $('.courses_home_page .tum_single').click(function () {
    let tab = $(this).data('tab');
    $('.courses_home_page .tab_content').hide();
    $('.courses_home_page .' + tab).fadeIn();
    $('.tum_single').removeClass('active');
    $(this).addClass('active');
  });

  //Course detail
  $('.comment_slider').owlCarousel({
    loop: true,
    nav: true,
    dots: false,
    margin: 36,
    stagePadding: 36,
    navText: [
      '<i class="icon chevron_left"></i>',
      '<i class="icon chevron_right"></i>',
    ],
    responsive: {
      1280: {
        items: 3,
      },
      768: {
        items: 2,
      },
      320: {
        items: 1,
      },
    },
  });

  $('.course_detail_page .tcd_single').click(function () {
    let tab = $(this).data('tab');
    $('.course_detail_page .tab_content').hide();
    $('.course_detail_page .' + tab).fadeIn();
    $('.tcd_single').removeClass('active');
    $(this).addClass('active');
  });

  // Profile
  $('#wpforo .tum_single').click(function () {
    let tab = $(this).data('tab');
    $('#wpforo .tab_content').hide();
    $('#wpforo .' + tab).fadeIn();
    $('.tum_single').removeClass('active');
    $(this).addClass('active');
  });
  $('#wpforo .tab_profile button').click(function () {
    let tab = $(this).data('tab');
    $('#wpforo .profile_container').hide();
    $('#wpforo .' + tab).fadeIn();
    $('#wpforo .tab_profile button').removeClass('active');
    $(this).addClass('active');
  });
  $('.close_survey').click(function () {
    $('.popup_survey').fadeOut();
  });
  $('.open_user_options').click(function () {
    if($(this).hasClass('active')){
      $(this).removeClass('active');
      $('.user_options').fadeOut('fast');
    }else{
      $(this).addClass('active');
      $('.user_options').fadeIn('fast');
    }
  });
  $('.close_cart').click(function () {
      $('.cart_popup').fadeOut('fast');
  });
  $('.open_cart_popup').click(function () {
      $('.cart_popup').fadeIn('fast');
    
  });
  
  // Auth
  new Auth();
  
  // downloads
  new Downloads();

  // curso valoraciones
  new Valoration_Course();

  new WPFORO();
});
